import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0A0E27] border-t border-[#1E293B] py-12" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-106">
        <div className="text-[#94A3B8] text-sm" data-id="element-107">
          © {currentYear} CRM Kraft. Alle Rechte vorbehalten.
        </div>
        <div className="flex gap-6 text-sm text-[#94A3B8]" data-id="element-108">
          <Link to="/impressum" className="hover:text-white transition-colors" data-id="element-109">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-white transition-colors" data-id="element-110">
            Datenschutz
          </Link>
        </div>
      </div>
    </footer>;
}